import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                close: 'close'
            }
        }
    }

    init() {
        document.querySelectorAll('.o-nav_open').forEach((elt) => {
            elt.addEventListener('click', () => {
                this.open();
            });
        });
    }

    open() {
        this.el.classList.add('-opened');
        this.call('stop', 'Scroll');
    }

    close() {
        this.el.classList.remove('-opened');
        this.call('start', 'Scroll');
    }
}
